module.exports = __webpack_public_path__ + "static/media/picard.4be99006.svg";